import 'moment/locale/fi'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import { render } from 'react-dom'
import 'react-toastify/dist/ReactToastify.css'
import App from './App'
import { configureAmplify } from './config/amplify'
//import { initializeGoogleOptimize } from './config/googleOptimize'
import { initializeGTM } from './config/googleTagManager'
//import { initializeHotjar } from './config/hotjar'
import './index.css'
import './translations/i18n'

configureAmplify()
// change this for testing
// if (process.env.NODE_ENV === 'production') {
//   initializeHotjar()
// }
initializeGTM()
//initializeGoogleOptimize()

render(<App />, document.getElementById('root') as HTMLElement)
